<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Cadastrar Tipo de Veículo
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div
                                                    class="alert alert-primary"
                                                    role="alert"
                                                >
                                                    <strong>Atenção!</strong> Agora você pode informar uma
                                                                              faixa de kilometragem para cada tipo de
                                                                              veículo, desta
                                                                              forma, assim que um usuário for realizar
                                                                              uma
                                                                              reserva,
                                                                              ele informará qual distância pretende
                                                                              rodar, e
                                                                              o sistema
                                                                              irá sugerir o tipo de veículo ideal para
                                                                              determinada
                                                                              distância.
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div
                                                    class="alert alert-dark"
                                                    role="alert"
                                                >
                                                    <strong>Observação!</strong> Informar um raio de
                                                                                 kilometragem não é obrigatório, se os
                                                                                 dois
                                                                                 campos
                                                                                 estiverem em branco, o tipo de veículo
                                                                                 será
                                                                                 sugerido em
                                                                                 todas as distâncias informadas. Se
                                                                                 apenas o
                                                    <strong>KM Final</strong> estiver em branco, será
                                                                                 considerado como "infinito".
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label
                                                        for="description"
                                                    >
                                                        <span class="required">*</span>
                                                        Descrição:
                                                    </label
                                                    >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="vehicleType.description"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label
                                                        for="description"
                                                    >
                                                        <span class="required">*</span>
                                                        KM Inicial:
                                                    </label
                                                    >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="vehicleType.km_start"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label
                                                        for="description"
                                                    >
                                                        <span class="required">*</span>
                                                        KM Final:
                                                    </label
                                                    >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="vehicleType.km_end"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <hr/>
                                        <div class="block text-right">
                                            <router-link
                                                to="/vehicleTypes"
                                                class="btn btn-back"
                                            >
                                                <i class="fa fa-arrow-left mr-2"></i>
                                                Voltar
                                            </router-link>
                                            <a
                                                class="btn btn-add"
                                                @click="save"
                                            >
                                                Salvar
                                                <i class="fa fa-save ml-2"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getMessage} from "../../composables/message";

export default {
    data() {
        return {

            vehicleType: {
                description: "",
                model_id: "",
                km_end: "",
                km_start: "",
            },
        };
    },

    methods: {
        save: function () {
            const self = this;
            let api = self.$store.state.api + "vehicleTypes/save";

            let fd = new FormData();

            fd.append("id", self.vehicleType.id);
            fd.append("description", self.vehicleType.description);
            fd.append("km_end", self.vehicleType.km_end);
            fd.append("km_start", self.vehicleType.km_start);

            if (self.vehicleType.id) {
                api += "/" + self.vehicleType.id;
            }

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    this.$router.push("/vehicleTypes");
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getVehicleType: function (id) {
            const self = this;
            const api =
                self.$store.state.api +
                "vehicleTypes/" +
                id

            self.$http
                .get(api)
                .then((response) => {
                    self.vehicleType = response.data.data[0];
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
    },
    mounted: function () {
        const self = this;

        let id = self.$route.params.id;
        if (id) {
            self.getVehicleType(id);
        }
    },
};
</script>
<style scoped>
ul.sortable li.list-group-item {
    padding: 0.4rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid #ccc;
}

ul.sortable li.list-group-item.selected {
    padding: 0.4rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid #ccc;
    background-color: #d5e6ff;
    color: #424241;
}

ul.sortable li.list-group-item i {
    color: #0b033b;
    margin-right: 0;
    margin-top: 4px;
    float: right;
}

.entity-filter-selection {
    max-height: 250px;
    min-height: 100px;
    overflow-y: scroll;
    background-color: white !important;
}

.switch-label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 2px;
}

.switch-description {
    color: #6c757d;
    font-size: 0.875rem;
    font-style: italic;
}

.custom-control-label {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/VehicleTypes/Add.vue